import mixpanel from "mixpanel-browser";
import { getAllSources, getIsOnpremise, getPlatform, isWebView } from ".";
import constants from "./constants";
import { isEmpty } from "lodash";
import { MIXPANEL_OTHER_EVENTS } from "./mixpanelEvents";
import Store from "./Store";
import getEnv from "./getEnv";
var LOCALSTORAGE = "localStorage";
function getUserProperties(userData) {
  var _userData$details, _userData$details2, _userData$details3, _userData$details4, _userData$details5, _userData$details6;
  var sources = getAllSources(userData);
  var sourceIds = sources.map(function (source) {
    return source.uuid;
  });
  var PLATFORMS = constants.PLATFORMS;
  var platform = Object.keys(PLATFORMS).find(function (p) {
    return PLATFORMS[p] === getPlatform();
  });
  return {
    Name: userData === null || userData === void 0 || (_userData$details = userData.details) === null || _userData$details === void 0 ? void 0 : _userData$details.name,
    Email: userData === null || userData === void 0 || (_userData$details2 = userData.details) === null || _userData$details2 === void 0 ? void 0 : _userData$details2.email,
    sourceIdentifier: (userData === null || userData === void 0 || (_userData$details3 = userData.details) === null || _userData$details3 === void 0 ? void 0 : _userData$details3.source_identifier) || "personal_user",
    country: userData === null || userData === void 0 || (_userData$details4 = userData.details) === null || _userData$details4 === void 0 ? void 0 : _userData$details4.country,
    vertical: userData === null || userData === void 0 || (_userData$details5 = userData.details) === null || _userData$details5 === void 0 ? void 0 : _userData$details5.vertical,
    clientName: userData === null || userData === void 0 || (_userData$details6 = userData.details) === null || _userData$details6 === void 0 ? void 0 : _userData$details6.client_name,
    sourceIds: sourceIds,
    isMobielApp: isWebView(),
    platform: platform
  };
}
var isLoggedInUser = function isLoggedInUser() {
  var _Store$getRawState;
  return !isEmpty((_Store$getRawState = Store.getRawState()) === null || _Store$getRawState === void 0 ? void 0 : _Store$getRawState.user);
};
function initMixpanel() {
  var MIXPANEL_TOKEN = getEnv("NEXT_PUBLIC_MIXPANEL_TOKEN");
  var isProduction = getEnv("NEXT_PUBLIC_APP_ENV") === constants.PRODUCTION;
  var isBundledOfflineApp = getEnv("NEXT_PUBLIC_IS_BUNDLED_OFFLINE") === "true";
  var isOnPremise = getIsOnpremise();
  if (isOnPremise || isBundledOfflineApp || !MIXPANEL_TOKEN) {
    return function () {};
  }
  mixpanel.init(MIXPANEL_TOKEN, {
    debug: !isProduction,
    track_pageview: false,
    persistence: LOCALSTORAGE
  });
  return function (userData) {
    mixpanel.identify(userData.username);
    var userProperties = getUserProperties(userData);
    mixpanel.people.set_once(userProperties);
  };
}
var trackPageView = function trackPageView(pageName) {
  var isOnPremise = getIsOnpremise();
  var MIXPANEL_TOKEN = getEnv("NEXT_PUBLIC_MIXPANEL_TOKEN");
  if (isOnPremise || !MIXPANEL_TOKEN || !isLoggedInUser()) {
    return;
  }
  try {
    mixpanel.track_pageview({
      page: pageName
    });
    trackDuration(MIXPANEL_OTHER_EVENTS.PAGE_EXIT);
  } catch (e) {
    console.log("Mixpanel not initialized :", e);
  }
};
var trackEvent = function trackEvent(name, props) {
  var isOnPremise = getIsOnpremise();
  var MIXPANEL_TOKEN = getEnv("NEXT_PUBLIC_MIXPANEL_TOKEN");
  if (isOnPremise || !MIXPANEL_TOKEN || !isLoggedInUser()) {
    return;
  }
  if (isEmpty(props)) {
    mixpanel.track(name);
    return;
  }
  try {
    mixpanel.track(name, props);
  } catch (e) {
    console.log("Mixpanel not initialized :", e);
  }
};
var trackPageExit = function trackPageExit(page) {
  var isOnPremise = getIsOnpremise();
  var MIXPANEL_TOKEN = getEnv("NEXT_PUBLIC_MIXPANEL_TOKEN");
  if (isOnPremise || !MIXPANEL_TOKEN || !isLoggedInUser()) {
    return;
  }
  mixpanel.track(MIXPANEL_OTHER_EVENTS.PAGE_EXIT, {
    page: page
  });
};

/* this function will track duration will target event is hit */
var trackDuration = function trackDuration(targetEvent) {
  var isOnPremise = getIsOnpremise();
  var MIXPANEL_TOKEN = getEnv("NEXT_PUBLIC_MIXPANEL_TOKEN");
  if (isOnPremise || !MIXPANEL_TOKEN || !isLoggedInUser()) {
    return;
  }
  mixpanel.time_event(targetEvent);
};
export { initMixpanel, trackPageView, trackEvent, trackPageExit, trackDuration };